
import cloneDeep from 'lodash/cloneDeep'
import get from 'lodash/get'
import merge from 'lodash/merge'
import pipe from '@converdy/utils/pipe'
import toObject from '@converdy/utils/to-object'
import deepValues from '@converdy/utils/deep-values'

import replaceId from './replace-id'
import generateId from './generate-id'
import generateValidSlug from '@converdy/c-utils/generate-valid-funnel-slug';

const getChildIds = require('@converdy/c-utils/get-child-ids')

// slug is optional. If no slug is provided a unique slug will be created
export default function clonePage (page, elements, slugs, slug) {
  const childIds = getChildIds(
    page.id,
    { [ page.id ]: page, ...elements }
  )

  const directChildIds = deepValues(page.slots)

  const newPageId = generateId()

  const newSlug = slugs ? generateValidSlug(slug || get(page, 'settings.slug'), slugs) : `page-${newPageId}`

  const newPage = merge(
    cloneDeep({
      ...page,
      id: newPageId
    }),
    {
      settings: {
        slug: newSlug
      }
    }
  )

  const clonedEntities = pipe(
    childIds.map(
      childId => elements[childId]
    )
  )(
    toObject(
      child => child.id,
      child => child
    ),
    cloneDeep
  )

  directChildIds.forEach(
    directChildId => {
      clonedEntities[directChildId].parentId = newPageId
    }
  )

  /*
   * for the id replacement the page needs to be included in entities
   * since the ids in the slots need to also be replaced
   */
  const clonedEntitiesAndPage = { [ newPageId ]: newPage, ...clonedEntities }

	childIds.forEach(
    childId => {
      replaceId(
        childId,
        clonedEntitiesAndPage        
      )
    }
  )

  const { [ newPageId ]: clonedPage, ...clonedElements } = clonedEntitiesAndPage

	return { 
    elements: clonedElements,
    page: clonedPage,
		pageId: newPageId
	}
}
